import { useQuery } from '@tanstack/react-query';
import { BillingRecordData } from 'models/billing';
import { WorklistData } from 'models/worklist';
import { BillingRecordsDownloadError } from 'services/errors/BillingRecordsDownloadError';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { getReportUrlById } from 'services/reports';
import { showUsaFeature } from 'utils/app';
import { createFileUrlFromBuffer } from 'utils/helpers';
import { queryKeys, SCHEMA_NAMES, sdk } from 'utils/query';
import { containsBillingReportAttachment } from 'utils/worklist';

export const getBillingReportUrlById = async (variables: { id?: string }) => {
  const { id } = variables;

  if (!id) throw new EmptyParametersError();

  const billingRecord = await sdk.data.documents.findById<BillingRecordData>(SCHEMA_NAMES.usBillingRecords, id);

  if (!billingRecord?.data.output?.fileToken) throw new BillingRecordsDownloadError();

  const data = await sdk.files.retrieve(billingRecord.data.output?.fileToken);

  return createFileUrlFromBuffer(data);
};

export const useGetWorklistReportPdf = (item?: WorklistData) => {
  const id = item?.attachments?.reportId;

  return useQuery({
    queryKey: [queryKeys.worklistReportPdf, id],
    queryFn: () =>
      showUsaFeature && containsBillingReportAttachment({ item })
        ? getBillingReportUrlById({ id })
        : getReportUrlById({ id }),
    enabled: !!id,
    gcTime: 0,
  });
};
